var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowLeft18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "keyboard_arrow_left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M11.7787 12.4425L8.34375 9L11.7787 5.5575L10.7213 4.5L6.22125 9L10.7213 13.5L11.7787 12.4425Z",
    fill: "#696F88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowLeft18);
export default __webpack_public_path__ + "static/media/keyboard-arrow-left-18.870c8568d7cb1bada4c2788eb4cf52bc.svg";
export { ForwardRef as ReactComponent };